import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Forms from '../views/Forms.vue'
import Header from '../components/Header.vue'

const routes = [
    {
        path: '/',
        name: 'Home',
        components: {
            default: Home
        }
    },
    {
        path: '/forms',
        name: 'Forms',
        components: {
            default: Forms,
            TopHeader: Header
        }
    },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
